module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/store_images/4_33d508ca2d9da3d760fc87a8a3909edc.png";